export default __webpack_public_path__ + "static/media/click.c82ea7b0.mp3";